import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-select-list',
  templateUrl: './side-select-list.component.html',
  styleUrls: ['./side-select-list.component.scss']
})
export class SideSelectListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
